/* =============================================
   Component: Product Card (TLPC)
   File: card-product-tlpc.js
   Flavour select + pack pill switching — price,
   compare price, form variant id, add-to-cart state.
   Pills row scrolls with plain CSS (overflow-x) — no JS.
============================================= */

document.addEventListener('DOMContentLoaded', function () {
  /* ---- pills row — mouse drag-to-scroll (touch scrolls natively via CSS) ---- */
  var dragRow = null;
  var rowDragged = false;
  var rowStartX = 0;
  var rowStartScroll = 0;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return;
    var row = e.target.closest('.card-tlpc__pills');
    if (!row || row.scrollWidth <= row.clientWidth) return;
    dragRow = row;
    rowDragged = false;
    rowStartX = e.clientX;
    rowStartScroll = row.scrollLeft;
  });

  document.addEventListener('pointermove', function (e) {
    if (!dragRow) return;
    var dx = e.clientX - rowStartX;
    if (Math.abs(dx) > 5) rowDragged = true;
    if (rowDragged) dragRow.scrollLeft = rowStartScroll - dx;
  });

  ['pointerup', 'pointercancel'].forEach(function (type) {
    document.addEventListener(type, function () {
      dragRow = null;
    });
  });

  /* a drag must not fire the pill click underneath */
  document.addEventListener('click', function (e) {
    if (rowDragged && e.target.closest('.card-tlpc__pills')) {
      e.preventDefault();
      e.stopPropagation();
    }
    rowDragged = false;
  }, true);

  function readVariants(card) {
    var dataEl = card.querySelector('[data-card-variants]');
    if (!dataEl) return null;
    try {
      return JSON.parse(dataEl.textContent);
    } catch (err) {
      return null;
    }
  }

  function selectedOptions(card) {
    var selected = [];
    card.querySelectorAll('[data-card-select]').forEach(function (sel) {
      selected[parseInt(sel.dataset.optionIndex, 10)] = sel.value;
    });
    card.querySelectorAll('.card-tlpc__pills').forEach(function (group) {
      var active = group.querySelector('.card-tlpc__pill.is-active');
      if (active) selected[parseInt(group.dataset.optionIndex, 10)] = active.getAttribute('data-option-value');
    });
    return selected;
  }

  function findVariant(variants, selected) {
    for (var i = 0; i < variants.length; i++) {
      var match = true;
      for (var j = 0; j < selected.length; j++) {
        if (selected[j] !== undefined && variants[i].options[j] !== selected[j]) {
          match = false;
          break;
        }
      }
      if (match) return variants[i];
    }
    return null;
  }

  function setAtcState(card, available, variant) {
    var atc = card.querySelector('.card-tlpc__atc');
    if (!atc) return;
    var label = atc.querySelector('span');
    atc.disabled = !available;
    if (label) {
      label.textContent = available
        ? atc.getAttribute('data-text-add')
        : atc.getAttribute('data-text-soldout');
    }
  }

  function update(card) {
    var variants = readVariants(card);
    if (!variants) return;

    /* bold title part follows the selected flavour */
    var titleFlavour = card.querySelector('[data-card-title-flavour]');
    var flavourSelect = card.querySelector('[data-card-select]');
    if (titleFlavour && flavourSelect) titleFlavour.textContent = flavourSelect.value;

    var variant = findVariant(variants, selectedOptions(card));
    if (!variant) {
      setAtcState(card, false, null);
      return;
    }

    var priceEl = card.querySelector('[data-card-price]');
    if (priceEl) priceEl.textContent = variant.price;

    var compareEl = card.querySelector('[data-card-compare]');
    if (compareEl) {
      if (variant.compare) {
        compareEl.textContent = variant.compare;
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }

    var input = card.querySelector('.product-variant-id');
    if (input) input.value = variant.id;

    /* title + media links follow the selected variant */
    card.querySelectorAll('[data-card-title-link]').forEach(function (link) {
      var baseUrl = link.dataset.baseUrl || link.getAttribute('href').split('?')[0];
      link.setAttribute('href', baseUrl + '?variant=' + variant.id);
    });

    /* featured image follows the selected variant */
    var imageEl = card.querySelector('[data-card-image]');
    if (imageEl && variant.image && imageEl.getAttribute('src') !== variant.image) {
      imageEl.setAttribute('src', variant.image);
      imageEl.setAttribute('alt', variant.image_alt || '');
    }

    setAtcState(card, variant.available, variant);
  }

  /* pack pills */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.card-tlpc__pill');
    if (!pill || pill.classList.contains('is-active')) return;

    var card = pill.closest('[data-card-tlpc]');
    var group = pill.closest('.card-tlpc__pills');
    if (!card || !group) return;

    group.querySelectorAll('.card-tlpc__pill').forEach(function (p) {
      var isActive = p === pill;
      p.classList.toggle('is-active', isActive);
      p.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    update(card);
  });

  /* flavour select */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-card-select]');
    if (!sel) return;
    var card = sel.closest('[data-card-tlpc]');
    if (!card) return;
    update(card);
  });

  /* init each card on load so links carry the current variant immediately */
  document.querySelectorAll('[data-card-tlpc]').forEach(update);
});